"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggle = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledToggle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  > span {\n    color: ", ";\n    font-size: 0.875rem;\n  }\n\n  .toggle {\n    margin: 0 0 0 8px;\n\n    input[type='checkbox'].switch {\n      &:checked {\n        + div {\n          background-color: ", ";\n        }\n      }\n\n      &:focus {\n        + div {\n          padding: 0;\n          border: ", "\n            solid ", ";\n          outline: 2px solid black;\n          outline-offset: 2px;\n        }\n      }\n    }\n  }\n"], ["\n  ", ";\n\n  > span {\n    color: ", ";\n    font-size: 0.875rem;\n  }\n\n  .toggle {\n    margin: 0 0 0 8px;\n\n    input[type='checkbox'].switch {\n      &:checked {\n        + div {\n          background-color: ", ";\n        }\n      }\n\n      &:focus {\n        + div {\n          padding: 0;\n          border: ", "\n            solid ", ";\n          outline: 2px solid black;\n          outline-offset: 2px;\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Colors = _a.theme.Colors, variant = _a.variant;
    return "".concat(variant === 'dark' ? Colors.Brand.normal : null);
}, function (_a) {
    var Colors = _a.theme.Colors, variant = _a.variant;
    return "".concat(variant === 'dark' ? Colors.Brand.normal : null);
}, function (_a) {
    var Borders = _a.theme.Dimensions.Borders;
    return Borders.x2;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
});
var templateObject_1;
